import React, { useContext, useState, useImperativeHandle } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const PlaceholderMMAEditor = ({
  responsiveAdRepository,
  pageContext,
  editorRef,
}) => {
  const i18n = useContext(I18nContext);
  const [errors, setErrors] = useState([]);

  useImperativeHandle(editorRef, () => ({
    saveAdAsync: () => {
      setErrors([]);

      return responsiveAdRepository.savePlaceholderMMA(pageContext)
        .then((data) => {
          if (_.isFinite(data.value)) {
            _.defaults(data, {
              Type: 'Responsive',
            });
            return data;
          }

          return false;
        })
        .catch((response) => {
          if (response) {
            const errorMsgs = [];
            const errorsFromResponse = _.unique(response, false, error => error.Code);

            _.forEach(errorsFromResponse, (error) => {
              const genericErrorMessage = i18n.getString(`Multimedia_Ad_Error_${error.Code}`)
                  || i18n.getString('ErrorNumber_-1');
              errorMsgs.push(genericErrorMessage);
            });

            setErrors(errorMsgs);
            return false;
          }
          return false;
        });
    },
  }));

  return (
    <div className={classNames('placeholder-mma-editor', 'crud-audience-ad-react', 'crud-multimedia-ad-react')}>
      <div className={classNames('ad-edit-and-preview-container')}>
        <div className="generic-errors error">
          {
              errors.map((errMsg, index) => (
                <div className="error" key={index}>
                  {errMsg}
                </div>
              ))
            }
        </div>
      </div>
    </div>
  );
};

PlaceholderMMAEditor.propTypes = {
  responsiveAdRepository: PropTypes.shape({
    savePlaceholderMMA: PropTypes.func.isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    CurrentCustomer: PropTypes.shape({
      Id: PropTypes.number,
    }),
    CurrentAccount: PropTypes.shape({
      Id: PropTypes.number,
    }),
  }).isRequired,
  editorRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
};
